var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "Home", "data-page": "home" } },
    [
      _c("div", { attrs: { id: "MobileExpandedMap" } }, [
        _c("div", {
          staticClass: "expanded_closebt",
          on: {
            click: function($event) {
              return _vm.closeExpandedMap()
            }
          }
        }),
        _c("div", { staticClass: "expanded_instructions" }, [
          _vm._v(
            "\n            Drag to navigate, pinch to zoom in/out\n        "
          )
        ]),
        _c("div", { staticClass: "map_container" })
      ]),
      _c("div", { attrs: { id: "MobileBottomFixed" } }),
      _c("appModal", {
        ref: "appModalRef",
        attrs: { countries: _vm.DBCountries }
      }),
      _c(
        "div",
        { attrs: { id: "HomeWrapper" } },
        [
          _c("appHeader", {
            attrs: {
              bgColor: "white",
              page: "home",
              latestNews: _vm.latestNews
            },
            on: { headerMenuClicked: _vm.menuClicked }
          }),
          _c("div", { staticClass: "main" }, [
            _c("div", { staticClass: "main_inner" }, [
              _c(
                "section",
                {
                  staticClass: "main_section",
                  on: {
                    click: function($event) {
                      _vm.showMapModal = false
                    }
                  }
                },
                [_vm._m(0)]
              ),
              _c(
                "section",
                {
                  staticClass: "main_section section_mapcontrols",
                  on: {
                    click: function($event) {
                      _vm.showMapModal = false
                    }
                  }
                },
                [
                  _c("div", { staticClass: "section_content" }, [
                    _vm._m(1),
                    _c(
                      "div",
                      { staticClass: "section_row mapcontrols_buttons" },
                      _vm._l(_vm.datasetsParams, function(
                        datasetObj,
                        datasetInc
                      ) {
                        return _c(
                          "button",
                          {
                            key: datasetObj.id,
                            staticClass: "app_button",
                            class:
                              _vm.selectedDatasetIDForMenu == datasetObj.id
                                ? "selected"
                                : "",
                            on: {
                              click: function($event) {
                                return _vm.selectDataset(datasetObj)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(datasetObj.label) +
                                "\n                            "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticClass: "home_mobile_mapcontrols_selectbox" },
                      [
                        _c("v-select", {
                          staticClass: "actionblock_selectbox app_selectbox",
                          attrs: {
                            items: _vm.datasetsParams,
                            "return-object": true,
                            label: "Choose a dataset",
                            solo: ""
                          },
                          on: { change: _vm.selectDataset },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function(data) {
                                return [
                                  _c("div", { staticClass: "item_wrapper" }, [
                                    _c("div", { staticClass: "item_text" }, [
                                      _vm._v(_vm._s(data.item.label))
                                    ])
                                  ])
                                ]
                              }
                            },
                            {
                              key: "item",
                              fn: function(data) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "item_wrapper",
                                      attrs: { "data-item": data.item.id }
                                    },
                                    [
                                      _c("div", { staticClass: "item_text" }, [
                                        _c("span", {
                                          staticClass: "item_icon"
                                        }),
                                        _vm._v(_vm._s(data.item.label))
                                      ])
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _vm.hasTaxHavensData
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "section_row mapcontrols_toggler app_toggler home_opacify_block",
                            class: _vm.togglerFreezed ? "freezed" : "",
                            attrs: {
                              "data-selected": _vm.selectedTaxHavens
                                ? "on"
                                : "off",
                              "data-opacified": _vm.hideMapContent
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "toggler_wrapper",
                                attrs: {
                                  "data-dataset": _vm.selectedDataset.id
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "toggler_label first",
                                    class: !_vm.selectedTaxHavens
                                      ? "selected"
                                      : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleTaxHavens()
                                      }
                                    }
                                  },
                                  [
                                    _vm.selectedDataset.id == "global-profit"
                                      ? _c("span", [_vm._v("Lost")])
                                      : _vm.selectedDataset.id ==
                                        "offshore-financial"
                                      ? _c("span", [_vm._v("Owned")])
                                      : _vm._e()
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "toggler_toggle",
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleTaxHavens()
                                      }
                                    }
                                  },
                                  [_c("div", { staticClass: "toggle_chip" })]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "toggler_label second",
                                    class: _vm.selectedTaxHavens
                                      ? "selected"
                                      : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleTaxHavens()
                                      }
                                    }
                                  },
                                  [
                                    _vm.selectedDataset.id == "global-profit"
                                      ? _c("span", [_vm._v("Won")])
                                      : _vm.selectedDataset.id ==
                                        "offshore-financial"
                                      ? _c("span", [_vm._v("Hosted")])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedDataset.id != undefined &&
                    _vm.DBDatasetsTexts[_vm.selectedDataset.id] != undefined &&
                    _vm.DBDatasetsTexts[_vm.selectedDataset.id]
                      .Tax_haven_definition != undefined &&
                    _vm.DBDatasetsTexts[_vm.selectedDataset.id]
                      .Tax_haven_definition != ""
                      ? _c(
                          "div",
                          {
                            staticClass: "section_row home_opacify_block",
                            attrs: { "data-opacified": _vm.hideMapContent }
                          },
                          [
                            _vm.DBDatasetsTexts[_vm.selectedDataset.id]
                              .Tax_haven_definition != undefined
                              ? _c(
                                  "span",
                                  { staticClass: "text_maxwidthed bolder" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.DBDatasetsTexts[
                                            _vm.selectedDataset.id
                                          ].Tax_haven_definition
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _c(
                "section",
                {
                  staticClass: "main_section section_map home_opacify_block",
                  attrs: {
                    id: "Wrapper_map",
                    "data-opacified": _vm.hideMapContent,
                    "data-taxhavens": _vm.selectedTaxHavens ? "true" : "false"
                  }
                },
                [
                  _c("MapModal", {
                    attrs: {
                      countryTooltipData: _vm.countryTooltipData,
                      countriesMapData: _vm.countriesMapData,
                      datasetID: _vm.selectedDatasetIDForMenu,
                      selectedYear: _vm.mapCurrentYear,
                      isShow: _vm.showMapModal,
                      countryDBDataset: _vm.mapModalCountryDBDataset,
                      countryDB: _vm.mapModalCountryDB,
                      DBEffectiveTax: _vm.DBEffectiveTax,
                      DBProfitShiftingTaxHavenTooltipData:
                        _vm.DBProfitShiftingTaxHavenTooltipData,
                      indicatorObj: _vm.selectedIndicator,
                      counterpartObj: _vm.selectedCounterpart,
                      mapShowTaxHavens: _vm.selectedTaxHavens
                    },
                    on: { closeMapModal: _vm.handleCloseMapModal }
                  }),
                  _c(
                    "div",
                    { staticClass: "section_content section_map nopad" },
                    [
                      _vm.DBDatasetsTexts["global-profit"] != undefined
                        ? _c("div", { staticClass: "map_title" }, [
                            _vm.selectedDataset.id == "effective-tax"
                              ? _c("span", [
                                  _vm._v(
                                    "How does capital taxation vary worldwide?"
                                  )
                                ])
                              : !_vm.selectedTaxHavens
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.DBDatasetsTexts[
                                        _vm.selectedDataset.id
                                      ].Map_title_default
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.DBDatasetsTexts[
                                        _vm.selectedDataset.id
                                      ].Map_title_tax_haven
                                    )
                                  )
                                ])
                          ])
                        : _vm._e(),
                      _vm.selectedDataset.label != undefined && _vm.isDataLoaded
                        ? _c("div", { staticClass: "map_legend" }, [
                            _vm.selectedDataset.id != "offshore-real-estate"
                              ? _c("div", { staticClass: "legend_title" }, [
                                  _vm.selectedIndicator.id != "corp_tax_lost"
                                    ? _c("div", { staticClass: "title_item" }, [
                                        _vm.selectedIndicator.homeLabel !=
                                        undefined
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "title_indicator"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedIndicator
                                                      .homeLabel
                                                  )
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "title_indicator"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedIndicator.label
                                                  )
                                                )
                                              ]
                                            ),
                                        _vm.hasTaxHavensData
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "title_taxhavens",
                                                attrs: {
                                                  "data-taxhavens": _vm.selectedTaxHavens
                                                    ? "true"
                                                    : ""
                                                }
                                              },
                                              [
                                                !_vm.selectedTaxHavens &&
                                                _vm.selectedDataset.id ==
                                                  "global-profit"
                                                  ? _c("span", [_vm._v("lost")])
                                                  : _vm.selectedTaxHavens &&
                                                    _vm.selectedDataset.id ==
                                                      "global-profit"
                                                  ? _c("span", [_vm._v("won")])
                                                  : !_vm.selectedTaxHavens &&
                                                    _vm.selectedDataset.id ==
                                                      "offshore-financial"
                                                  ? _c("span", [
                                                      _vm._v("owned")
                                                    ])
                                                  : _vm.selectedTaxHavens &&
                                                    _vm.selectedDataset.id ==
                                                      "offshore-financial"
                                                  ? _c("span", [
                                                      _vm._v("hosted")
                                                    ])
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _c("div", { staticClass: "title_item" }, [
                                        _c(
                                          "div",
                                          { staticClass: "title_indicator" },
                                          [
                                            _vm._v(
                                              "\n                                        Corporate tax revenue\n                                    "
                                            )
                                          ]
                                        ),
                                        _vm.hasTaxHavensData
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "title_taxhavens",
                                                attrs: {
                                                  "data-taxhavens": _vm.selectedTaxHavens
                                                    ? "true"
                                                    : ""
                                                }
                                              },
                                              [
                                                !_vm.selectedTaxHavens
                                                  ? _c("span", [_vm._v("lost")])
                                                  : _vm.selectedTaxHavens
                                                  ? _c("span", [_vm._v("won")])
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "title_indicator" },
                                          [
                                            _vm._v(
                                              "\n                                        as a share of corporate tax revenue collected\n                                    "
                                            )
                                          ]
                                        )
                                      ]),
                                  _vm.selectedIndicator.homeUnit != undefined
                                    ? _c("div", { staticClass: "title_unit" }, [
                                        _vm._v(
                                          " (in " +
                                            _vm._s(
                                              _vm.selectedIndicator.homeUnit
                                            ) +
                                            ")"
                                        )
                                      ])
                                    : _c("div", { staticClass: "title_unit" }, [
                                        _vm._v(
                                          " (in " +
                                            _vm._s(_vm.selectedIndicator.unit) +
                                            ")"
                                        )
                                      ]),
                                  _c("div", { staticClass: "title_sep" }, [
                                    _vm._v("|")
                                  ]),
                                  _c("div", { staticClass: "title_param" }, [
                                    _vm._v(_vm._s(_vm.mapCurrentYear))
                                  ])
                                ])
                              : _c("div", { staticClass: "legend_title" }, [
                                  _c("div", { staticClass: "title_item" }, [
                                    _vm._v(
                                      "Real estate owned in London, Paris, Côte d'Azur, Dubai, Singapore, Amsterdam and Oslo as a share of GDP (in %)"
                                    )
                                  ]),
                                  _c("div", { staticClass: "title_sep" }, [
                                    _vm._v("|")
                                  ]),
                                  _c("div", { staticClass: "title_param" }, [
                                    _vm._v(_vm._s(_vm.mapCurrentYear))
                                  ])
                                ])
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "map_container" },
                        [
                          _c("mapChoropleth", {
                            ref: "appMapRef",
                            attrs: {
                              mapData: _vm.countriesMapData,
                              indicatorUnit: _vm.inidicatorUnit,
                              hasTimeline: false,
                              hasTaxHavensData: _vm.hasTaxHavensData,
                              indicatorID: _vm.selectedIndicator.id,
                              datasetID: _vm.selectedDataset.id,
                              displayWorldTotal: false
                            },
                            on: {
                              countryClicked: _vm.handleMapCountryClicked,
                              currentYear: _vm.callbackMapCurrentYear
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "map_expand_bt",
                              on: {
                                click: function($event) {
                                  return _vm.expandMap()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "bt" }, [
                                _vm._v("Expand map")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "section_content section_quicklink" },
                    [
                      _c(
                        "div",
                        { staticClass: "quicklink_container" },
                        [
                          _c("div", { staticClass: "quicklink_title" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.selectedDataset.label) +
                                "\n                            "
                            )
                          ]),
                          _c(
                            "nuxt-link",
                            {
                              staticClass: "quicklink_link",
                              attrs: {
                                to: "/dataset/" + _vm.selectedDataset.id
                              }
                            },
                            [
                              _vm._v(
                                "\n                                View dataset page\n                            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "section",
                {
                  staticClass: "main_section section_ctas",
                  on: {
                    click: function($event) {
                      _vm.showMapModal = false
                    }
                  }
                },
                [
                  _c("div", { staticClass: "section_content" }, [
                    _c(
                      "div",
                      { staticClass: "ctas_container" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "cta_block",
                            attrs: { "data-block": "country" },
                            on: {
                              click: function($event) {
                                return _vm.openModal("country")
                              }
                            }
                          },
                          [_vm._m(2)]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "cta_block",
                            attrs: { "data-block": "dataset" },
                            on: {
                              click: function($event) {
                                return _vm.openModal("dataset")
                              }
                            }
                          },
                          [_vm._m(3)]
                        ),
                        _c(
                          "nuxt-link",
                          {
                            staticClass: "cta_block wide",
                            attrs: {
                              to: "/research-briefs",
                              "data-block": "briefs"
                            }
                          },
                          [
                            _c("div", { staticClass: "cta_content" }, [
                              _c("div", { staticClass: "block_title" }, [
                                _vm._v("Research briefs")
                              ]),
                              _c("div", { staticClass: "block_button" }, [
                                _c("div", { staticClass: "button_label" }, [
                                  _vm._v("Discover latest...")
                                ]),
                                _c("div", { staticClass: "button_bt" }, [
                                  _vm._v("Go to briefs")
                                ])
                              ])
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "section",
                {
                  staticClass: "main_section section_news nomargin",
                  on: {
                    click: function($event) {
                      _vm.showMapModal = false
                    }
                  }
                },
                [
                  _c("div", { staticClass: "section_content" }, [
                    _c("div", { staticClass: "news_carousel" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "touch",
                              rawName: "v-touch:swipe.left",
                              value: _vm.swipeSlideNext,
                              expression: "swipeSlideNext",
                              arg: "swipe",
                              modifiers: { left: true }
                            },
                            {
                              name: "touch",
                              rawName: "v-touch:swipe.right",
                              value: _vm.swipeSlidePrev,
                              expression: "swipeSlidePrev",
                              arg: "swipe",
                              modifiers: { right: true }
                            }
                          ],
                          staticClass: "carousel_wrapper",
                          style: {
                            width:
                              _vm.DBNews.length *
                                (_vm.carouselItemWidth +
                                  _vm.carouselItemMargin) +
                              "px",
                            left: _vm.carouselLeftPos + "px"
                          }
                        },
                        _vm._l(_vm.DBNews, function(newsObj, newsIndex) {
                          return _c("div", { staticClass: "carousel_item" }, [
                            _c("div", {
                              staticClass: "item_image",
                              style:
                                "background: linear-gradient(0deg, #164193 0%, #164193 100%), url(" +
                                newsObj.image +
                                "), lightgray; background-size: cover; background-repeat: no-repeat;"
                            }),
                            _c("div", { staticClass: "item_content" }, [
                              _c("div", { staticClass: "content_date" }, [
                                _vm._v(_vm._s(newsObj.date))
                              ]),
                              _c("div", { staticClass: "content_title" }, [
                                _vm._v(_vm._s(newsObj.title))
                              ]),
                              _c("div", { staticClass: "content_desc" }, [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(
                                      _vm.truncateText(newsObj.description, 120)
                                    ) +
                                    "\n                                        "
                                )
                              ])
                            ]),
                            newsObj.link != undefined && newsObj.link != ""
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "item_extlink",
                                    attrs: {
                                      href: newsObj.link,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("Read more")]
                                )
                              : _vm._e()
                          ])
                        }),
                        0
                      )
                    ]),
                    _c("div", { staticClass: "carousel_arrows" }, [
                      _c("div", {
                        staticClass: "carousel_arrow",
                        class:
                          Math.abs(Math.round(_vm.carouselLeftPos)) <= 0
                            ? "disabled"
                            : "",
                        attrs: { "data-arrow": "prev" },
                        on: {
                          click: function($event) {
                            return _vm.gotoCarousel("prev")
                          }
                        }
                      }),
                      _c("div", {
                        staticClass: "carousel_arrow",
                        class: _vm.disabledNextArrow ? "disabled" : "",
                        attrs: { "data-arrow": "next" },
                        on: {
                          click: function($event) {
                            return _vm.gotoCarousel("next")
                          }
                        }
                      })
                    ])
                  ])
                ]
              )
            ])
          ]),
          _c("appFooter", { on: { headerMenuClicked: _vm.menuClicked } })
        ],
        1
      ),
      _c("cookiesConsent")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section_content" }, [
      _c("h1", { staticClass: "title_home" }, [
        _vm._v(
          "\n                            Atlas of the\n                            "
        ),
        _c("span", { staticClass: "title_orange" }, [_vm._v("Offshore World")])
      ]),
      _c(
        "p",
        { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
        [
          _vm._v(
            "\n                            The Atlas of the Offshore World is a new effort by the "
          ),
          _c(
            "a",
            {
              attrs: { href: "https://taxobservatory.world/", target: "_blank" }
            },
            [_vm._v("International Tax Observatory")]
          ),
          _vm._v(" and "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.nmbu.no/en/research/skatteforsk-tax-center",
                target: "_blank"
              }
            },
            [_vm._v("Skatteforsk - Norwegian Centre for Tax Research")]
          ),
          _vm._v(
            " to inform the global debate around international tax evasion and avoidance. It offers up-to-date information about the dynamic of profit shifting by multinational companies and offshore wealth.\n                        "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section_hr" }, [
      _c("div", { staticClass: "hr_text" }, [_vm._v("Datasets")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cta_content" }, [
      _c("div", { staticClass: "block_title" }, [_vm._v("Country reports")]),
      _c("div", { staticClass: "block_button" }, [
        _c("div", { staticClass: "button_label" }, [
          _vm._v("Choose a country")
        ]),
        _c("div", { staticClass: "input_wrapper" }, [
          _c("div", { staticClass: "input_icon" }),
          _c("input", {
            staticClass: "button_input",
            attrs: { placeholder: "e.g: France" }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cta_content" }, [
      _c("div", { staticClass: "block_title" }, [_vm._v("Datasets")]),
      _c("div", { staticClass: "block_button" }, [
        _c("div", { staticClass: "button_label" }, [
          _vm._v("Choose a dataset")
        ]),
        _c("div", { staticClass: "button_bt" }, [
          _vm._v("e.g: Offshore real estate")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a183b29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a183b29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/index.vue
// module id = +ptz
// module chunks = 1